/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".graph path,.graph rect{stroke:#fff}.statPanel{padding-top:10px}"];
export { styles as styles };
